@import "@/scss/use-bootstrap-mixins.scss";

.container {
  margin: 0 auto;
  margin-top: 12px;

  display: block;
  justify-content: space-between;
  gap: 20px;

  min-height: 260px;

  @include media-breakpoint-up(lg) {
    display: flex;
  }

  .image {
    display: flex;
    align-items: center;
    justify-content: center;

    @include media-breakpoint-down(lg) {
      display: none;
    }

    img {
      max-width: 240px;
    }
  }

  .descriptor_info {
    flex: 1;

    @include media-breakpoint-down(lg) {
      margin-bottom: 10px;
    }

    .top_section {
      display: flex;

      .first {
        flex: 1;

        .title {
          font-size: 24px;
          text-decoration: underline;
          margin: 0 !important;
          font-weight: 600 !important;
        }
      }

      .last > div:first-of-type {
        display: flex;
        flex-direction: column;
        @include media-breakpoint-up(lg) {
          display: none !important;
        }
      }
    }

    .inclusions span:first-of-type {
      display: none;
    }

    .inclusions div {
      margin-bottom: 0;
      margin-top: 4px;
    }

    .inclusions {
      @include media-breakpoint-up(lg) {
        display: none !important;
      }
    }

    svg {
      path {
        stroke: #555;
      }
    }

    .descriptor_size {
      display: block;
      font-size: 12px;
    }

    .descriptor_name {
      display: block;
      font-weight: 500 !important;
      padding: 8px 0 0 0;
    }

    .descriptor_description {
      padding-bottom: 8px !important;
      margin: 0 !important;
      font-size: 14px;
    }
  }

  .descriptor_content {
    flex: 1;

    .tags {
      @include media-breakpoint-down(lg) {
        display: none;
      }
    }

    .inclusions {
      @include media-breakpoint-down(lg) {
        display: none;
      }
    }

    svg {
      path {
        stroke: #555;
      }
    }
  }
}
